
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/best-halloween-events-around-the-world",
      function () {
        return require("private-next-pages/blog/best-halloween-events-around-the-world.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/best-halloween-events-around-the-world"])
      });
    }
  